export const getBaseUrl = (path: string) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;
  if (baseUrl === undefined) {
    baseUrl = "http://localhost:8004";
  }
  baseUrl = baseUrl + path;
  return baseUrl;
};
